import { format } from "date-fns";

// Formats a date, or "" when it's missing or invalid.
export const safeDate = (d, pattern = "MMM d, h:mm a") => {
  if (!d) return "";
  try {
    return format(new Date(d), pattern);
  } catch (_) {
    return "";
  }
};
